import type { ComboboxOption } from '@standardsdigital/ui-components/Combobox';
import RadioGroup from '@standardsdigital/ui-components/RadioGroup';
import RadioGroupItem from '@standardsdigital/ui-components/RadioGroupItem';
import Select from '@standardsdigital/ui-components/Select';
import SelectItem from '@standardsdigital/ui-components/SelectItem';
import { useTranslation } from 'react-i18next';
import FieldStatusWrapper from 'components/global/FieldStatusWrapper/FieldStatusWrapper';

interface SubscriptionTypeSelectProps {
  options: ComboboxOption[];
  value: number;
  onChange: (value: number) => void;
  isDirty: boolean;
  disabled: boolean;
}

function SubscriptionTypeSelect({
  options,
  value,
  onChange,
  isDirty,
  disabled,
}: Readonly<SubscriptionTypeSelectProps>) {
  const { t } = useTranslation();
  const currentValue = String(value);

  if (options.length <= 3) {
    return (
      <FieldStatusWrapper isDirty={isDirty}>
        <RadioGroup
          label={t('serviceLevels.form.subscriptionType')}
          layout="horizontal"
          value={currentValue}
          onValueChange={(nextValue) => onChange(Number(nextValue))}
          required
          disabled={disabled}
        >
          {options.map((option) => (
            <RadioGroupItem
              key={option.value}
              value={option.value}
              label={option.label}
              disabled={disabled}
            />
          ))}
        </RadioGroup>
      </FieldStatusWrapper>
    );
  }

  return (
    <FieldStatusWrapper isDirty={isDirty}>
      <Select
        label={t('serviceLevels.form.subscriptionType')}
        value={currentValue}
        onChange={(event) => onChange(Number(event.target.value))}
        required
        disabled={disabled}
      >
        {options.map((option) => (
          <SelectItem value={option.value} key={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </Select>
    </FieldStatusWrapper>
  );
}

export default SubscriptionTypeSelect;
